export default "__VITE_ASSET__COiAGJ7l__"